import actions from "@/store/modules/announcements/actions";
const state = {};
export type State = typeof state;

export default {
  namespaced: true,
  actions,
};
